import { MediaSubFile } from '@/media/entity/MediaSubFile';

export function getFrameUrl(mediaSubFile: MediaSubFile, frame: number = 1) {
  if (mediaSubFile.externalLink?.endsWith('vindex.json')) {
    return mediaSubFile.externalLink.replace('vindex.json', `f${frame}.jpg`);
  }

  return mediaSubFile.externalLink;
}
